











































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Smokecrib from "../../../store/entities/smokecrib";
class PagefactoryRequest{
  cId:Number;
  ftId:Number;
  wId:Number;
  fId:Number;
}
@Component
export default class CreatSmokecribs extends AbpBase {
  pagefactoryrequest: PagefactoryRequest = new PagefactoryRequest();
  @Prop({ type: Boolean, default: false }) value: boolean;
  smokecrib: Smokecrib = new Smokecrib();
  idisable:boolean = false;
  selwarehouselist = [];
  selfloorlist = [];
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  get factory(){
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.filterlist;
  }
   get floor() {
    return this.$store.state.floor.filterlist;
  }
  
  save() {
    (this.$refs.smokecribForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true;
        await this.$store.dispatch({
          type: "smokecrib/create",
          data: this.smokecrib,
        });
        (this.$refs.smokecribForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel() {
    (this.$refs.smokecribForm as any).resetFields();
    this.$emit("input", false);
     this.selwarehouselist = [];
    this.selfloorlist = [];
  }
  smokecribRule = {
    ftId: [{type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wId: [{type:"number",required: true, message: "请选择库房", trigger: "change" }],
    mac: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [{type:"number",required: true, message: "请选择楼层", trigger: "change" }],
    LocationName: [{ required: true, message: "请填写垛位号", trigger: "blur" }],
    number: [{required: true, message: "请填写垛位编号", trigger: "blur" }],
    yieldly: [{required: true, message: "请填写烟叶产地", trigger: "blur" }],
    year: [{required: true, message: "请填写烟叶年份", trigger: "blur" }],
    grade: [{required: true, message: "请填写烟叶等级", trigger: "blur" }],
  };
  selfactory(value:Number){
    this.pagefactoryrequest.ftId = value;
    if(value !=0 && value != undefined){
      this.getselwarehouse();
    }
  }
  selwarehouse(value:Number){
    this.pagefactoryrequest.wId = value;
  if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.smokecrib.fId = 0;
      this.selfloorlist = [];
    }
  }
   selfloor(value:Number){
    this.pagefactoryrequest.fId = value;
  }
    async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagefactoryrequest,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagefactoryrequest,
    });
  }
}
